module.exports = __webpack_public_path__ + "static/Flora-Dark-6d14deb3a20ed7507fc9906f2f01e949.svg";